import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BehaviorSubject,Observable, of } from 'rxjs';
import { CampaignDetails, CampaignListSorting, Languages, smsAdmin } from './campaign.interface';
import { uiClientsConfig } from 'admin-ui-v2-config';

interface testEmailResponse {
  isActionSuccess: boolean,
  data: string,
  validationErrors: string[]
}

@Injectable({
  providedIn: 'root'
})

export class CampaignService {

  constructor(private http: HttpClient) { }

  sendCampaignMailsApi: string = "api/v1/platform/send-campaign-mails";
  sendCampaignSMSApi: string = "api/v1/platform/twilio-sms-campaign/";
  marketingAutomationCampaignApi: string = "api/v1/platform/marketing-automation-campaign";
  brandManagementApi: string = "api/v1/platform/brand-management/";
  unlayerTokenApi:string = "api/v1/platform/unlayer-editor-token";
  sendEmailCampaignApi: string = "api/v1/platform/send-campaign-mails/campaign-control";
  smsRegulatoryMMessageApi: string = "api/v1/platform/brand-sms-regulatary-message";
  subdomain: string = window.location.hostname.split("-")[0];

  private languagesList: Languages[] = [
    { code: 'en', name: 'English', default: true },
    { code: 'es', name: 'Spanish', default: false },
    { code: 'ru', name: 'Russian', default: false },
  ];

  activeTab = new BehaviorSubject<number>(0);
  activeTab$ = this.activeTab.asObservable();

  activePageStandard = new BehaviorSubject<number>(1);
  activePageStandard$ = this.activePageStandard.asObservable();

  activePageArchive = new BehaviorSubject<number>(1);
  activePageArchive$ = this.activePageArchive.asObservable();

  standardListSorting = new BehaviorSubject<CampaignListSorting>({
    sortOrder : 'DESC',
    sortBy : 'createdDateTimeUtc',
    columnName : '',
  });
  standardListSorting$ = this.standardListSorting.asObservable();

  archiveListSorting = new BehaviorSubject<CampaignListSorting>({
    sortOrder : 'DESC',
    sortBy : 'createdDateTimeUtc',
    columnName : '',
  });
  archiveListSorting$ = this.archiveListSorting.asObservable();



  private languagesSubject = new BehaviorSubject<Languages[]>(this.languagesList);
  getAllLanguages$: Observable<Languages[]> = this.languagesSubject.asObservable();
  private fileUploadProcessEnded = new BehaviorSubject<boolean>(false)
  isFileUploadEnded = this.fileUploadProcessEnded.asObservable()
  changeFileUploadStatus(modalClosed: boolean) {
      this.fileUploadProcessEnded.next(modalClosed)
  }




  sendTestMail(incomingObject: any): Observable<testEmailResponse> {
    let obj = {
      subject: incomingObject.subject ? incomingObject.subject : "Testing, Testing - One, Two, Three",
      emailDisplayName: incomingObject.emailDisplayName,
      emailPreviewText: incomingObject.emailPreviewText,
      content: incomingObject.html,
      toEmailAddress: incomingObject.emailList,
      fromEmailAddress: incomingObject.fromEmailAddress,
      replyToEmailAddress: incomingObject.replyToEmailAddress,
      isTestModeEnabled: true
    }
    return this.http.post<any>(this.sendCampaignMailsApi, obj);
  }

  saveCampaign(incomingObject: CampaignDetails, status: string): Observable<any> {
    let payLoad = {
      campaignName: incomingObject.campaignName,
      description: incomingObject.description,
      emailSubject: incomingObject.emailSubject,
      emailDisplayName: incomingObject.emailDisplayName,
      emailPreviewText: incomingObject.emailPreviewText,
      replyToEmailAddress: incomingObject.replyToEmailAddress,
      fromEmailAddress: incomingObject.fromEmailAddress,
      selectedLists: incomingObject.selectedLists,
      emailContent: incomingObject.emailContent,
      settings: incomingObject.settings,
      smsContent: incomingObject.smsContent,
      voiceContent: incomingObject.voiceContent,
      selectedChannels:incomingObject.selectedChannels,
      oldChannels:incomingObject.oldChannels,
      status: status,
      isReportingDisabled : incomingObject.isReportingDisabled ? 1 : 0
    }
    return this.http.post<any>(this.marketingAutomationCampaignApi, payLoad);
  }

  updateCampaign(incomingObject: CampaignDetails, id:string, status: string): Observable<any> {
    let payLoad = {
      campaignName: incomingObject.campaignName,
      description: incomingObject.description,
      emailSubject: incomingObject.emailSubject,
      emailDisplayName: incomingObject.emailDisplayName,
      emailPreviewText: incomingObject.emailPreviewText,
      replyToEmailAddress: incomingObject.replyToEmailAddress,
      fromEmailAddress: incomingObject.fromEmailAddress,
      selectedLists: incomingObject.selectedLists,
      emailContent: incomingObject.emailContent,
      settings: incomingObject.settings,
      smsContent: incomingObject.smsContent,
      voiceContent: incomingObject.voiceContent,
      selectedChannels:incomingObject.selectedChannels,
      status: status,
      isArchived : incomingObject.isArchived ? 1 : 0,
      isReportingDisabled : incomingObject.isReportingDisabled ? 1 : 0
    }

    return this.http.put<any>(this.marketingAutomationCampaignApi + `/${id}`, payLoad);
  }

  copyCampaign(incomingObject: any): Observable<any> {
    let payLoad = {
      campaignName: incomingObject.campaignName,
      description: incomingObject.description,
      emailSubject: incomingObject.emailSubject,
      emailDisplayName: incomingObject.emailDisplayName,
      emailPreviewText: incomingObject.emailPreviewText,
      replyToEmailAddress: incomingObject.replyToEmailAddress,
      fromEmailAddress: incomingObject.fromEmailAddress,
      selectedLists: incomingObject.selectedLists,
      emailContent: incomingObject.emailContent,
      settings: incomingObject.settings,
      selectedChannels: incomingObject.selectedChannels,
      oldChannels: incomingObject.oldChannels,
      smsContent: incomingObject.smsContent,
      voiceContent: incomingObject.voiceContent,
      status: 'DRAFT',
      isArchived : 0,
      isReportingDisabled : incomingObject.isReportingDisabled
    }
    return this.http.post<any>(this.marketingAutomationCampaignApi + '/copy-campaign', payLoad);
  }


  getAllCampaigns(page: number, sortBy: string, sortOrder: string, limit: number, search : string): Observable<any> {
    const obj = { "limit": limit, "pageNumber": page, "sortBy": sortBy, "sortOrder": sortOrder,  "isArchiveList" : 0 , "search": search? search: ''};

    return this.http.get<any>(this.marketingAutomationCampaignApi + "/", { params: obj })
  }

  getAllArchivedCampaigns(page: number, sortBy: string, sortOrder: string, limit: number, search : string): Observable<any> {
    const obj = { "limit": limit, "pageNumber": page, "sortBy": sortBy, "sortOrder": sortOrder, "isArchiveList" : 1, "search": search? search: ''};

    return this.http.get<any>(this.marketingAutomationCampaignApi + "/", { params: obj })
  }

  getArchiveTabConfiguration(): Observable<any> {
    const obj = {"subDomain": this.subdomain };
    return this.http.get<any>(this.brandManagementApi + `get-archive-tab-configuration/${this.subdomain}`)
  }
  // prospect-lists/get-lists?pageNumber=1&limit=2&sortBy=totalRows&sortOrder=ASC

  getAllProspectsLists(page: number, sortBy: string, sortOrder: string, limit: number,search: string): Observable<any> {
    const obj = {"pageNumber": page, "limit": limit, "sortBy": sortBy, "sortOrder": sortOrder, "search": search? search: ''};

    return this.http.get<any>(this.marketingAutomationCampaignApi + "/prospect-lists/get-lists/", { params: obj })
  }

  getAllFromEmails(): Observable<any> {
    return this.http.get<any>(this.marketingAutomationCampaignApi + "/from-emails-list/from-emails")
  }

  getList(id:string, limit:number, page:number): Observable<any> {
    const obj = {"pageNumber": page, "limit": limit };

    return this.http.get<any>(this.marketingAutomationCampaignApi + `/prospect-lists/get-prospects/${id}`, { params: obj })
  }

  getListUpdatedStatus(ids:string): Observable<any> {
    const obj = {"ids": ids };

    return this.http.get<any>(this.marketingAutomationCampaignApi + `/campaign-status`, { params: obj })
  }

  getCampaignById(id:string){
    return this.http.get<any>(this.marketingAutomationCampaignApi + `/${id}`)
  }

  generateUnlayerToken(){
    return this.http.get<any>(this.unlayerTokenApi + '/')
  }
  getSmsRegulatoryMessage(){
    return this.http.get<any>(this.smsRegulatoryMMessageApi + '/')
  }
  updateSmsRegulatoryMessage(payload:smsAdmin){
    return this.http.put<any>(this.smsRegulatoryMMessageApi + '/',payload)
  }

  changeCampaignStatus(id:string, status: string): Observable<any> {
    const obj = {id: id, status: status}
    return this.http.post<any>(this.sendEmailCampaignApi + `/${id}/${status}`, {params: obj} )
  }

  public updateAllowedLanguages(allowedLanguages: { [code: string]: boolean }): void {
    // Filter the languages list to only include languages that are allowed.
    const filteredLanguages = this.languagesList.filter(language =>language.code === 'en' || allowedLanguages[language.code] === true);
    this.languagesSubject.next(filteredLanguages);
  }

  sendTest(incomingObject: any, type:string): Observable< HttpResponse<any>> {
    let subURL = '';
    if(type ==='SMS' || type === 'MMS'){
      subURL = "/send-sms/"
    }
    if(type ==='IVR'){
      subURL = "/send-ivr/"
    }
    return this.http.post<any>(this.sendCampaignSMSApi+uiClientsConfig.customerUrlPrefix+subURL, incomingObject,  { observe: 'response' });
  }

  validateEmail(email:string) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
}
